import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Users, BookOpen } from 'lucide-react';
import { Course } from '../types';
import { useCart } from '../context/CartContext';
import copy from '../copy';

interface CourseCardProps {
  course: Course;
}

const CourseCard: React.FC<CourseCardProps> = ({ course }) => {
  const { addItem } = useCart();

  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault();
    addItem(course);
  };

  const formatPrice = (price: number) => {
    return `${copy.comun_simbolo}${price} ${copy.comun_moneda}`;
  };

  return (
    <div className="card group">
      <div className="relative overflow-hidden rounded-xl mb-6">
        <img
          src={course.image}
          alt={course.title}
          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
        />
      </div>

      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm text-accent-600 font-semibold bg-accent-50 px-3 py-1 rounded-full">
            {course.category}
          </span>
          <span className="text-sm text-primary-500 font-medium">{course.level}</span>
        </div>

        <h3 className="text-xl font-semibold text-primary-900 line-clamp-2 group-hover:text-accent-600 transition-colors">
          {course.title}
        </h3>

        <p className="text-primary-600 text-sm line-clamp-2 leading-relaxed">
          {course.shortDescription}
        </p>

        <div className="flex items-center space-x-6 text-sm text-primary-500">
          <div className="flex items-center space-x-2">
            <Clock className="w-4 h-4" />
            <span>{course.duration}</span>
          </div>
          <div className="flex items-center space-x-2">
            <Users className="w-4 h-4" />
            <span>{course.students.toLocaleString()}</span>
          </div>
          <div className="flex items-center space-x-2">
            <BookOpen className="w-4 h-4" />
            <span>{course.lessons} {copy.cursos_lecciones}</span>
          </div>
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-primary-100">
          <div className="flex items-center space-x-3">
            <span className="text-3xl font-bold text-accent-600">
              {formatPrice(course.price)}
            </span>
          </div>
        </div>

        <div className="flex space-x-3 pt-4">
          <Link
            to={`/curso/${course.id}`}
            className="btn-secondary flex-1 text-center"
          >
            {copy.cursos_ver_detalle}
          </Link>
          <button
            onClick={handleAddToCart}
            className="btn-primary flex-1"
          >
            {copy.cursos_agregar_carrito}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCard; 